/**
 * Shown while the link's status is being resolved (PF-6119).
 *
 * Its own screen rather than `OnboardingFlowLoadingScreen`, whose copy is "Deine Kursdaten werden
 * geladen" — there are no course data here, and a patient sent a link about their signature should
 * not be told something unrelated is loading.
 */
import styled from 'styled-components';
import { space } from '../../../styles/onboardingUiTokens';
import { signatureRecaptureCopy } from '../config/copy';
import { Body, H1, LoadingSpinner, OnboardingBody, OnboardingFooter, OnboardingHeader, OnboardingLayout } from '../ui';

const copy = signatureRecaptureCopy.checkingLink;

export function CheckingLinkScreen() {
  return (
    <OnboardingLayout currentStep={1} totalSteps={3} hideForward>
      <OnboardingHeader hideBackButton hideProgress />
      <OnboardingBody disableSupportHint>
        <ContentStack>
          <LoadingSpinner />
          <H1>{copy.title}</H1>
          <Body variant="document">{copy.body}</Body>
        </ContentStack>
      </OnboardingBody>
      <OnboardingFooter hidePrivacyNote />
    </OnboardingLayout>
  );
}

const ContentStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${space.lg};
  padding-bottom: ${space.xl};
`;
